import React from 'react'
import cn from 'classnames'

import { IEnabledOrDisabledSquareProps } from './interface'
import './styles.scss'
import { NOT_APPLICABLE } from '../OptionScaleStep'
import { NA } from '../../../Reports/constants'

const bc = 'enabled-or-disabled-square'

const EnabledOrDisabledSquare: React.FC<IEnabledOrDisabledSquareProps> = ({ enabled = false, value }) => {
  const isNA = value === NOT_APPLICABLE
  return (
    <div className={cn(`${bc}__disabled`, { [`${bc}__enabled`]: enabled, [`${bc}__na`]: isNA })}>
      {isNA ? NA : value}
    </div>
  )
}

export default EnabledOrDisabledSquare
